<template>
  <div class="flex items-center justify-between w-full">
    <div class="grid gap-1.5 leading-none">
      <label
        v-if="label"
        :for="id"
        class="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
      >
        {{ label }}
      </label>
      <p
        v-if="description"
        class="text-sm text-gray-500"
      >
        {{ description }}
      </p>
    </div>
    <button
      type="button"
      role="switch"
      :id="id"
      :aria-checked="modelValue"
      :disabled="disabled"
      @click="toggle"
      class="peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-gray-200"
      :data-state="modelValue ? 'checked' : 'unchecked'"
    >
      <span
        class="pointer-events-none block h-5 w-5 rounded-full bg-white shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0"
        :data-state="modelValue ? 'checked' : 'unchecked'"
      />
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  modelValue: boolean
  disabled?: boolean
  label?: string
  description?: string
  id?: string
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
}>()

const id = computed(() => props.id || `switch-${Math.random().toString(36).slice(2)}`)

const toggle = () => {
  if (!props.disabled) {
    emit('update:modelValue', !props.modelValue)
  }
}
</script> 